<template>
  <b-button
    block
    variant="link-primary font-size-sm font-weight-bold"
    :class="[alignClass]"
    @click="$emit('change', data.field.key)">
    <span class="text-dark-50">{{ data.field.label }}</span>
    <div class="d-flex flex-column align-items-center ml-2 text-dark-25">
      <i
        class="position-relative fa fa-sm p-0 fa-caret-up"
        :class="[
          { 'text-dark-50' : data.field.key === $route.query.sort && getParams.ord === 'asc' }
        ]"
        style="bottom: -.25em; color: inherit;" />
      <i
        class="position-relative fa fa-sm p-0 fa-caret-down"
        :class="[
          { 'text-dark-50' : data.field.key === $route.query.sort && getParams.ord === 'desc' }
        ]"
        style="top: -.25em; color: inherit;" />
    </div>
  </b-button>
</template>

<script>
export default {
  name: 'SortButton',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {}
    },
    getParams: {
      type: Object,
      required: true,
      default: () => {}
    },
    align: {
      type: String,
      required: false,
      default: () => 'left'
    },
  },
  computed: {
    alignClass() {
      return this.align === 'left' ? '' : 'justify-content-end'
    },
  }
}
</script>
